(function componentForm($, Adzuki)
{
	'use strict';

	var form = {
		name: 'VerifySoftwareToken',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.success = function success(response)
	{
		var $modal = $('.modal');

		if (Adzuki.Form.hasError(response)) {
			return false;
		}

		$('#verified_software_token').val('1');
		$('#totp_checkbox').prop('checked', true).trigger('change');
		$modal.modal('hide');
	};
}(jQuery, window.Adzuki || {}));
